import { useEffect, useRef, useState } from "react";

const LETTERS = "driveflow".split("");
// Durées volontairement courtes : sur PSI, chaque ms compte pour le LCP/SI.
const PRELOAD_DURATION_MS = 320;
const EXIT_MS = 400;

// Intro cinématique desktop uniquement (désactivée sur mobile), sans framer-motion
export default function Preloader() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.matchMedia("(max-width: 767px)").matches) return false;
    return !sessionStorage.getItem("df_intro");
  });
  const [exiting, setExiting] = useState(false);
  const countRef = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const t0 = performance.now();
    let raf;
    let timer;
    const tick = (t) => {
      const p = Math.min((t - t0) / PRELOAD_DURATION_MS, 1);
      const c = Math.round(p * 100);
      if (countRef.current) countRef.current.textContent = String(c);
      if (barRef.current) barRef.current.style.width = `${c}%`;
      if (p < 1) raf = requestAnimationFrame(tick);
      else {
        sessionStorage.setItem("df_intro", "1");
        setExiting(true);
        timer = setTimeout(() => setShow(false), EXIT_MS);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-[#0A0A0A] flex items-center justify-center"
      style={{
        transform: exiting ? "translateY(-100%)" : "translateY(0)",
        transition: `transform ${EXIT_MS}ms cubic-bezier(0.76, 0, 0.24, 1)`,
      }}
    >
      <div className="text-center">
        <div className="overflow-hidden">
          <div className="font-display text-4xl sm:text-6xl font-light tracking-tighter text-white flex">
            {LETTERS.map((l, i) => (
              <span key={i} className="inline-block df-rise" style={{ animationDuration: "0.3s", animationDelay: `${0.02 + i * 0.02}s` }}>
                {l}
              </span>
            ))}
          </div>
        </div>
        <div className="mt-3 text-[10px] tracking-[0.5em] uppercase text-[#38BDF8] font-bold df-fade" style={{ animationDelay: "0.15s", animationDuration: "0.25s" }}>
          Technologies
        </div>
      </div>
      <div ref={countRef} className="absolute bottom-8 right-8 sm:bottom-12 sm:right-12 font-display text-6xl sm:text-8xl font-light tracking-tighter text-white/15 tabular-nums">
        0
      </div>
      <div ref={barRef} className="absolute bottom-0 left-0 h-[2px] bg-gradient-to-r from-[#38BDF8] to-[#4D8DFF]" style={{ width: "0%" }} />
    </div>
  );
}
